<ion-header>
  <ion-toolbar>
    <ion-title>Información adicional</ion-title>
    <ion-buttons slot="end">
      <ion-button color="dark" (click)="closeModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <!-- FORM -->
  <div class="formContainer reverseFlex">
    
    <div class="profileSelector" *ngIf="configService?.company_info?.allow_coupon_users">
      <h4>¿Quién usará este Bono?</h4>
      <div class="profileCircle" *ngFor="let profile of this.profiles"
        [class.selected]="selectedProfile?.id === profile.id" (click)="selectProfile(profile)">

        <div class="deleteIcon" (click)="deleteProfile(profile); $event.stopPropagation()" title="Eliminar perfil">
          ✕
        </div>

        <div class="avatarCircle">
          <!--Display the first letter of the name and the first letter of the last name-->
          {{ profile.name.split(' ')[0].charAt(0) }}{{ profile.name.split(' ')[1]?.charAt(0) }}
        </div>

        <span>{{ profile.name.split(' ')[0] }}</span>
      </div>
    </div>

    <mat-checkbox *ngIf="showUseMyDataCheckbox && configService?.company_info?.allow_coupon_users" (change)="useMyData($event)" 
                  [checked]="!configService?.company_info?.allow_coupon_users" 
                  [disabled]="!configService?.company_info?.allow_coupon_users">Utilizar mis datos</mat-checkbox>
    <app-form [questions]="couponQuestions1" (submit)="addToShoppingCart()"></app-form>
    <h4 *ngIf="couponQuestions2">¿Dónde se usará este Bono?</h4>
    <app-form *ngIf="couponQuestions2" [questions]="couponQuestions2" (submit)="addToShoppingCart()"></app-form>
    <button class="z-depth-2 smallButton" (click)="addToShoppingCart()">AGREGAR</button>
  </div>
</ion-content>